import { useState } from 'react';
import '../Style/FAQ.css';
// import aaa from '../Images/aaa.gif'

function FAQ() {
    const faqData = [
        {
            question: 'How do I know I can trust Riley?',
            answer:
                "Riley's advice is grounded in the latest pediatric research and expert knowledge. We work closely with pediatricians, child development specialists, and parenting experts to ensure our information is accurate and up-to-date. Plus, Riley learns from your experiences, becoming more personalized and helpful over time. Think of Riley as a best friend with a Ph.D. in child development who's always by your side!"
        },
        {
            question: "How will you keep my family's data private?",
            answer:
                "Your family's privacy is our top priority. We use bank-level encryption to protect your data, and we never share your information with third parties. Riley's personalized advice is generated just for you, based on the information you choose to share. You're always in control of your data, and you can delete it at any time."
        },
        {
            question: 'Do you offer a free trial?',
            answer:
                "We don’t offer a free trial, but we do provide a 14-day money-back guarantee—no questions asked! Try Riley risk-free, and if it’s not the right fit for you, we’ll refund your purchase within 14 days."
        },
        {
            question: 'Can I use Riley for other baby tracking needs?',
            answer:
                "Yes. Riley is not just a baby sleep-tracking app. It is an all-in-one parenting tool, helping parents track sleep, feeding, diaper changes, developmental milestones, and more."
        },
        {
            question: 'What can’t I ask Riley?',
            answer:
                "While Riley is knowledgeable about a wide range of parenting topics, it's not a substitute for professional medical advice. Riley should not be used to diagnose or treat any medical issue of any kind. For any health concerns or emergencies, always consult with your pediatrician or healthcare provider. Riley is here to support and guide you, but critical health decisions should always be made in consultation with medical professionals."
        }
    ];

    const [openIndexes, setOpenIndexes] = useState([]);

    const toggleFAQ = (index) => {
        setOpenIndexes((prev) =>
            prev.includes(index)
                ? prev.filter((i) => i !== index)
                : [...prev, index]
        );
    };

    return (
        <div className="container-fluid row FAQ pt-5 pb-5 d-flex justify-content-center align-items-center m-0">
            <div className="text-center col-10 p-4 mb-4">
                <h1 className="display-2 fw-bold">FAQ</h1>
                <p className="fw-bold">
                    Great answers are kind of our thing! Here are some answers to frequently asked questions to help you get started.
                </p>
            </div>
            {/* <div className=' col-8  img-aaa' >
                <img src={aaa} alt='' />
            </div> */}

            {faqData.map((item, index) => (
                <div
                    key={index}
                    className="slider-cu shadow p-5  mb-5 col-lg-8 fw-bold"
                    onClick={() => toggleFAQ(index)}
                    style={{ cursor: 'pointer' }}
                >
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}
                    >
                        <h4 className="m-0">{item.question}</h4>
                        <span style={{ fontSize: '24px', fontWeight: 'bold' }}>
                            {openIndexes.includes(index) ? '−' : '+'}
                        </span>
                    </div>
                   
                    <div className={`faq-body mt-3 text-start ${openIndexes.includes(index) ? 'open' : ''}`}>
                        {<p>{item.answer}</p>}
                        </div> 
                </div>
            ))}
        </div>
    );
}

export default FAQ;
